import { Injectable } from '@angular/core';
import WalletConnectProvider from '@walletconnect/web3-provider';
import Web3 from 'web3';
import { newKitFromWeb3 } from '@celo/contractkit';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { useWallet, WalletStatus } from '@terra-money/wallet-provider';
import {Wallet, Extension, LCDClient, MsgSend, Fee} from '@terra-money/terra.js'
import { CommonService } from './common.service';
import { BncClient } from '@binance-chain/javascript-sdk'
import TokenManagement, { crypto } from '@binance-chain/javascript-sdk'
import * as nearApi from 'near-api-js'
import { functionCall } from 'near-api-js/lib/transaction';
import { BN } from 'bn.js';
import { Router, ActivatedRoute } from '@angular/router';

var Tx = require('ethereumjs-tx');
@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  private kit : any
  isConnectedWallet = false
  connectedWalletAddress = ''
  balance = -1
  provider
  conversionRate
  sources
  source
  selectedSource
  sourceAmount
  convertedAmount
  toAddress
  transactionInitiated = false
  transactionId
  connectedWalletAddressModified
  availableRpcs = [
    "https://alfajores-forno.celo-testnet.org",
    "https://forno.celo.org",
    "https://bsc-dataseed.binance.org"
  ]
  terra
  extension
  baseURL
  net
  bnbClient
  bscContract
  web3
  fees
  upper_limit
  lower_limit
  gasFeesError = false
  nearWalletConnection
  constructor(private http : HttpClient, private common:CommonService, private route : ActivatedRoute, private router : Router) { 
    // this.terra = new LCDClient({
    //   URL: 'https://bombay-lcd.terra.dev',
    //   chainID: 'bombay-12'
    // });

    this.extension =  new Extension()
    this.initNearWallet()
    this.route.queryParams.subscribe(params => {
      const {transactionHashes, errorCode, errorMessage} = params
      if(transactionHashes && !errorCode){
        alert("transaction success")
        this.router.navigate([])
      }
      if((errorCode || errorMessage) ){
        alert("transaction failed")
        this.router.navigate([])
      }
    })
    
   }

  
  // connectToMetaMask(){
  //   let ethereum = window['ethereum'];
  //   if (typeof ethereum !== 'undefined') {
  //     console.log('MetaMask is installed!');
  //   }
  //   if (ethereum) {
  //     this.provider = ethereum;
  //     try {
  //       // Request account access
  //       ethereum.request({ method: 'eth_requestAccounts' }).then( (address:any) => {
  //         this.senderAddress = address[0]
  //         console.log("Account connected: ", address) // Account address that you had imported
  //       });
  //     } catch (error) {
  //       // User denied account access
  //       console.error("User denied account access");
  //     }
  //   }
  // }

  async connectWalletCusd(){
    this.provider = new WalletConnectProvider({
      rpc: {
        44787: "https://alfajores-forno.celo-testnet.org",
        42220: "https://forno.celo.org",
        56: "https://bsc-dataseed.binance.org"
      },
    });

    await this.provider.enable()

    //@ts-ignore
    const web3 = new Web3(this.provider)

    //@ts-ignore
    this.kit = newKitFromWeb3(web3)
    this.kit.defaultAccount = this.provider.accounts[0]
    if(!this.availableRpcs.includes(this.provider.rpcUrl)){
      alert("kindly connect supported chain wallet")
      this.disconnectWallet()
      return false
    }
    return this.kit.defaultAccount
  }

  async getBalance(address, source){
    let kit = this.kit
    //function to get value in CELO
    // let balance = await kit.celoTokens.kit.connection.web3.eth.getBalance(address)
    // let balance = await kit.web3.eth.getBalance(address)

    // function to get value in cUSD OR cEUR
    let stableToken = await kit.contracts.getStableToken(source)
    let bal = await stableToken.balanceOf(address)
    // let balance = bal.toNumber()
    // balance = (4.019935*(10^22))
    // balance = bal.c[0].concat(bal.c[1])
    // balance = JSON.stringify(bal.c[0])+JSON.stringify(bal.c[1])
    // console.log(bal.toString(), bal.c[0].toString()+bal.c[1].toString(), await kit.web3.utils.fromWei(bal.c[0].toString()+bal.c[1].toString(), 'ether'))
    // console.log(address)
    if(bal.e==19 || bal.e==18 || bal.e==20)
      return await kit.web3.utils.fromWei(bal.toString(), 'ether')
    else 
      return await kit.web3.utils.fromWei(bal.c[0].toString()+bal.c[1].toString(), 'ether')
    // return await kit.web3.utils.fromWei((bal.toString().split('e')[0].split('.').join('')).toString()+'0', 'ether')
    // if(bal.c[1])
    //   return await kit.web3.utils.fromWei(JSON.stringify(bal.c[0])+JSON.stringify(bal.c[1]), 'ether')
    // else{
    //   return await kit.web3.utils.fromWei(JSON.stringify(bal.c[0])+"00000000000000", 'ether')
    // }
      
  }

  async createTransaction(sendingAmount){
    let kit = this.kit
    // JSON.stringify(sendingAmount)
    let amount = kit.web3.utils.toWei(JSON.stringify(sendingAmount), 'ether')
    const stabletoken = await kit.contracts.getStableToken(this.source)
    try{
      // { feeCurrency: cUSDcontract.address }
      const tx = await stabletoken.transfer(this.toAddress, amount).send()
      // const tx = await stabletoken.transfer(this.toAddress, amount).sendAndWaitForReceipt()
      const receipt = await tx.waitReceipt()
      return receipt
      // return tx
    }catch(err){
      console.log(err)
      return false
    }
    
  }

  async connectWalletTerra(){
    

    let fromAddress

    await this.extension.request('connect').then(async data => {
      fromAddress = data.payload.address
      return fromAddress
    });

    return fromAddress
    this.extension.on("onConnect", (w: Wallet) => {
      console.log("connected to terra station")
      
    });

    
  }

  async connectWalletBinance(){
    this.provider = new WalletConnectProvider({
      rpc: {
        44787: "https://alfajores-forno.celo-testnet.org",
        42220: "https://forno.celo.org",
        56: "https://bsc-dataseed.binance.org"
      },
    });

    await this.provider.enable()

    //@ts-ignore
    this.web3 = new Web3(this.provider)

    // //@ts-ignore
    this.kit = newKitFromWeb3(this.web3)
    let tokenAddress = "0x55d398326f99059ff775485246999027b3197955";
    let minABI = [
      {
        "constant": true,
        "inputs": [
          {
            "name": "_owner",
            "type": "address"
          }
        ],
        "name": "balanceOf",
        "outputs": [
          {
            "name": "balance",
            "type": "uint256"
          }
        ],
        "payable": false,
        "type": "function"
      },
       // transfer
       {
        "constant": false,
        "inputs": [
          {
            "name": "_to",
            "type": "address"
          },
          {
            "name": "_value",
            "type": "uint256"
          }
        ],
        "name": "transfer",
        "outputs": [
          {
            "name": "",
            "type": "bool"
          }
        ],
        "type": "function"
      }
    ]
    //@ts-ignore
    this.bscContract = new this.web3.eth.Contract(minABI, tokenAddress)

    
    
    //@ts-ignore
    // let check = await web3.eth.getBalance(this.provider.accounts[0])
    // console.log(check)

    //@ts-ignore
    // await window.BinanceChain.request('connect').then(async data => {
    //   let fromAddress = data.payload.address
    //   console.log(fromAddress)
      
    //   return fromAddress
    // });
    // let accounts = await window.BinanceChain.requestAccounts()
    // let walletAddress = ''
    // console.log(accounts)
    // accounts[2].addresses.forEach(address => {
    //   if(address.type == 'bbc-mainnet'){
    //     walletAddress = address.address
    //   }
    // });
    // console.log(walletAddress)
//     //@ts-ignore
//    let bbc = await window.BinanceChain.request({method: "eth_getBalance", params: ["address", walletAddress]})
//    console.log(bbc)
    this.baseURL = "https://dex.binance.org"
    this.net = "mainnet"
    this.kit.defaultAccount = this.provider.accounts[0]
    this.bnbClient = new BncClient(this.baseURL);
    this.bnbClient.chooseNetwork(this.net)
    // let pkey = await crypto.generatePrivateKey()
    // let test = await this.bnbClient.getAccount(walletAddress)
    // let test = await this.bnbClient.getPrivateKeyFromKeyStore(walletAddress)
    // console.log(test.result.account_number)
    // let pkey = await this.bnbClient.getPrivateKey(walletAddress)
    // console.log(pkey)
    // let tkey = await this.bnbClient.getClientKeyAddress()
    // console.log(tkey)
    // let privKey = "DEADBEEF"
    // this.bnbClient.setPrivateKey('6a5ac6614e593f82fd2d08f9c81d543c1b04f1f3b22a3a902190a243a876ae1e')
    this.bnbClient.initChain()
    // if(!this.availableRpcs.includes(this.provider.rpcUrl)){
    //   alert("kindly connect supported chain wallet")
    //   this.disconnectWallet()
    //   return false
    // }
    // return this.kit.defaultAccount
    if(!this.availableRpcs.includes(this.provider.rpcUrl)){
      alert("kindly connect supported chain wallet")
      this.disconnectWallet()
      return false
    }
    let walletAddress = this.provider.accounts[0]
    return walletAddress
  }

  async initNearWallet(){
    const config = this.getNearConfig('mainnet')
    const near = await nearApi.connect({
      keyStore: new nearApi.keyStores.BrowserLocalStorageKeyStore(),
      ...config,
    });
    this.nearWalletConnection = new nearApi.WalletConnection(near, null)
  }
  async connectWalletNear(){
    if(!this.nearWalletConnection.isSignedIn()){
      this.nearWalletConnection.requestSignIn({successUrl:`${environment.APP_URL}/dashboard`, failureUrl:`${environment.APP_URL}/dashboard` }); 
    }
    console.log(this.nearWalletConnection.getAccountId())
    return  this.nearWalletConnection.getAccountId()
  }

  async getNearBalance(){
    const bal = 
    await this.nearWalletConnection.account().viewFunctionV1(
      `usn`,
      `ft_balance_of`,
      {account_id: this.nearWalletConnection.getAccountId()}
    )

    return bal/1000000000000000000
    // return nearApi.utils.format.formatNearAmount(bal)
  } 

  async getBalanceBinance(){
    let check = await this.bscContract.methods.balanceOf(this.provider.accounts[0]).call();
    // console.log(balance)
    // let check = await this.web3.eth.getBalance(this.provider.accounts[0])
    return check/1000000000000000000
    // return this.bnbClient.getBalance(this.connectedWalletAddress.toLowerCase())
  }

  async createTransactionBinance(amount){
    let tokenAddress = "0x55d398326f99059ff775485246999027b3197955";
    let minABI = [
       // transfer
      {
        "constant": false,
        "inputs": [
          {
            "name": "_to",
            "type": "address"
          },
          {
            "name": "_value",
            "type": "uint256"
          }
        ],
        "name": "transfer",
        "outputs": [
          {
            "name": "",
            "type": "bool"
          }
        ],
        "type": "function"
      }
    ]


    // var contract = new this.web3.eth.Contract(minABI, tokenAddress);
    // var count = this.web3.eth.getTransactionCount(this.connectedWalletAddress);
    // var rawTransaction = {
    //     "from": "0x26...",
    //     "nonce": this.web3.utils.toHex(count),
    //     "gasPrice": "0x04e3b29200",
    //     "gasLimit": "0x7458",
    //     "to": this.toAddress,
    //     "value": "0x0",
    //     "data": contract.methods.transfer.getData(this.toAddress, 10, {from: this.connectedWalletAddress}),
    //     "chainId": 0x03
    // };

    // var privKey = new Buffer('fc3...', 'hex');
    // var tx = new Tx(rawTransaction);

    // tx.sign(privKey);
    // var serializedTx = tx.serialize();

    // this.web3.eth.sendRawTransaction('0x' + serializedTx.toString('hex'), function(err, hash) {
    //     if (!err)
    //         console.log(hash);
    //     else
    //         console.log(err);
    // });
    // let decimals = this.web3.utils.toBN(18);
    // let amount = this.web3.utils.toBN(100);

    // let contract = new this.web3.eth.Contract(minABI, tokenAddress);
    // // calculate ERC20 token amount
    // let value = amount.mul(this.web3.utils.toBN(10).pow(decimals));
    // // call transfer function
    // console.log(amount)
    // contract.methods.transfer(this.toAddress, value).send({from: this.connectedWalletAddress})
    // .on('transactionHash', function(hash){
    //   console.log(hash);
    // });

    // const transfer = await this.bscContract.methods.transfer(this.toAddress, amount);
    // const encodedABI = await transfer.encodeABI();
    // // console.log(encodedABI)

    // this.bscContract.methods.transfer(
      
    //       {
    //           from: this.connectedWalletAddress,
    //           to: this.toAddress,
    //           gasPrice: '',
    //           gas: '',
    //           data: encodedABI
    //       },
     
    //   )
    //   .then((txHash) => console.log(txHash))
    //   .catch((error) => console.error);
    let samount = this.web3.utils.toWei(JSON.stringify(amount), 'ether')
    // let con = new this.web3.eth.Contract(minABI, tokenAddress)
    // con.methods.transfer(this.toAddress, samount).send({
    //   from: this.connectedWalletAddress
    // })
    // console.log("bnb trans", amount, this.bscContract)

   
    // let data = await this.bscContract.methods.transfer(this.toAddress, samount).send({
    //   from: this.connectedWalletAddress,
    // }).then((rec)=>{
    //   console.log(rec)
    //   return rec
    // })
    // const result = await this.bnbClient.transfer(this.connectedWalletAddress, this.toAddress, amount, 'BNB')
    // return result
    // this.bscContract.methods.transfer()
    // return this.web3.eth.sendTransaction({
    //   from:this.connectedWalletAddress,
    //   to:this.toAddress,
    //   value:  amount*1000000000000000000, 
    //   data: "0xdf"
    // })
    return this.bscContract.methods.transfer(this.toAddress, samount).send({
      from: this.connectedWalletAddress,
    })
  }

  async createTransactionTerra(sendingAmount){
 
    let uusd

    this.getTerraFees().subscribe(async (res:any)=>{
      uusd = +res.uusd * 1000000 
      const fee = new Fee(100000, { uusd: uusd });

      const send = new MsgSend(
        this.connectedWalletAddress,
        this.toAddress,
        { uusd: +sendingAmount*1000000 }
      );

      this.extension.post({
        msgs: [send],
        fee: fee
      })

      await this.extension.on("onPost", (success, res)=>{
        console.log(success, res)
        if(success.success){
          let postTransactionObj = {
            id: this.transactionId,
            txnHash: success.result.txhash,
            fromAddress: this.connectedWalletAddress
          }
          this.updateTransaction(postTransactionObj).subscribe((res:any)=>{
            this.common.hideLoader()
            this.convertedAmount = 0
            this.sourceAmount = 0
            // this.beneficiaryService.selectedBeneficiary = ''
            alert("transaction success")
          }, (err:any)=>{
            alert("transaction failed")
            this.common.hideLoader()
          })
          this.transactionInitiated = false
        }
        else if(!success.success && success.error.code==2){
          console.log("false1")
          this.common.hideLoader()
          this.transactionInitiated = false
          alert("You don't have enough Luna to pay transaction fees.")
        }
        else{
          console.log("false2")
          this.common.hideLoader()
          this.transactionInitiated = false
          alert("transaction failed")
        }
      })


    }, (err)=>{
      console.log(err)
      this.common.hideLoader()
      this.transactionInitiated = false
      alert("transaction failed")
    })
    

    
  }

  async createTransactionNear(sendingAmount, transactionId){
    try{
      // const amountInYocto = nearApi.utils.format.parseNearAmount('0.01')
      // const receipt = await this.nearWalletConnection.account().sendMoney(`114829bd655d8ecd8f1052ba13df2acb7c1d253ee3155ff54fe2c4156b0092e4`, amountInYocto)
      // const receipt = 
      // await this.nearWalletConnection.account().viewFunction(
      //   `usn`,
      //   `ft_transfer`,
      //   {
      //     amount: '1000000000000000000',
      //     receiver_id: `114829bd655d8ecd8f1052ba13df2acb7c1d253ee3155ff54fe2c4156b0092e4`,
      //     msg: 'hello'
      //   }
      // )

      // const contract = new Contract(
      //   this.nearWalletConnection.account(),
      //   'usn',
      //   {
      //     // name of contract you're connecting to
      //     viewMethods: ["ft_transfer"], // view methods do not change state but usually return a value
      //     changeMethods: ["ft_transfer"], // change methods modify state
      //   }
        
      // )

      // await contract.ft_transfer()

      // const response = await contract.ft_transfer({"receiver_id": "pdandwani.near", "amount": "1000000000000000000", "msg": "Test123"})
      // const receipt = await this.nearWalletConnection.account().signAndSendTransaction({
      //   receiverId: `114829bd655d8ecd8f1052ba13df2acb7c1d253ee3155ff54fe2c4156b0092e4`,

      // })


      const receipt = 
      await this.nearWalletConnection.account().functionCall({
        contractId: 'usn',
        methodName: `ft_transfer`,
        args: {
          amount: (+sendingAmount * 1000000000000000000).toString(),
          receiver_id: this.toAddress.toString(),
          msg: `${transactionId}`
        },
        gas: new BN('100000000000000'),
        attachedDeposit: 1
    })
      return true
    }catch(err){
      console.log(err)
      return false
    }
  }
  async disconnectWallet(){
    this.isConnectedWallet = false
    this.connectedWalletAddress = ''
    this.balance = -1
    this.nearWalletConnection.signOut()
    localStorage.removeItem("walletconnect")
    await this.provider?.disconnect()
  }

  sendTransaction(data){
    return this.http.post(`${environment.apiUrl}/transactions`, data)
  }

  getToAddress(){
    return this.http.get(`${environment.apiUrl}/wallet-addresses?source_currency.id=${this.selectedSource.id}`)
  }

  updateTransaction(data){
    let id = data.id
    delete data.id
    return this.http.put(`${environment.apiUrl}/transactions/${id}`, data)
  }

  getTerraFees(){
    return this.http.get(`https://fcd.terra.dev/v1/txs/gas_prices`)
  }

  getNearConfig(env){
    switch (env) {
      case "mainnet":
        return {
          networkId: "mainnet",
          nodeUrl: "https://rpc.mainnet.near.org",
          contractName: 'bitssa',
          walletUrl: "https://wallet.near.org",
          helperUrl: "https://helper.mainnet.near.org",
        };
      // This is an example app so production is set to testnet.
      // You can move production to mainnet if that is applicable.
      case "production":
      case "development":
      case "testnet":
        return {
          networkId: "testnet",
          nodeUrl: "https://rpc.testnet.near.org",
          contractName: 'bitssa',
          walletUrl: "https://wallet.testnet.near.org",
          helperUrl: "https://helper.testnet.near.org",
        };
      default:
        throw Error(`Unconfigured environment '${env}'. Can be configured in src/config.js.`);
    }
  }
 
}
